const ListTag = (props) => {
    return ( 
        <li className="mx-5">
            {props.children}
        </li>
     );
}
 
export default ListTag;